export * from './dropdows-data.adapter';